import styled from "styled-components";

export const LoadingContainer = styled.div`
    min-height: calc(100% - 35px);
    background: white;
    min-width: calc(100% - 20px);
    z-index: 1000;
    position: absolute;
    display: flex;
    justify-content: center;
    align-item: center;
    opacity: 0.7;
 
 & > div {
    @media (max-width: 993px) {
      position: fixed;
      margin: 20px;
      top: 70%;
    }
    
    @media (min-width: 994px) {
      align-items: center;
    }
 }
`
